/*
 *  Class Tab
 */
export default class Tab {
    constructor() {
        this.options = document.querySelectorAll('.tab__menu-option');
    }

    handleClick(e) {
        const options = e.target
            .closest('.tab__menu')
            .querySelectorAll('.tab__menu-option');
        for (const option of options) {
            option.classList.remove('active');
        }
        e.target.classList.add('active');
    }

    init() {
        for (const option of this.options) {
            option.addEventListener('click', this.handleClick.bind(this));
        }
    }
}
